var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hamburger-container",style:({color: _vm.$store.getters.skin.sidebarTextColor}),on:{"click":_vm.toggleSideBar}},[_c('i',{class:_vm.sidebar.collapsed ? 'el-icon-s-unfold': 'el-icon-s-fold',staticStyle:{"font-weight":"400"}},[(!_vm.sidebar.collapsed)?_c('span',[_vm._v("关闭侧边栏")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }